/* eslint-disable css-modules/no-unused-class, no-return-assign */
import { FC } from 'react';
import { AvatarProps } from './avatarTypes';
import styles from './avatar.module.scss';
import Tooltip from '../tooltip';

const Avatar: FC<AvatarProps> = (props: AvatarProps) => {
    const { name, avatarSrc, tooltipText, key, tooltipOnHover, size = '2.5rem', fontSize = '0.8125rem' } = props;
    function getNameAcronyms() {
        let nameAcronyms = '';
        const nameWords = name ? name.split(' ') : [];
        nameWords.map(word => (nameAcronyms = nameAcronyms.concat(word.trim().charAt(0))));
        return nameAcronyms.toLocaleUpperCase();
    }
    const getAvatar = () => {
        return avatarSrc ? (
            <img
                src={avatarSrc}
                className={styles.avatar}
                alt={name}
                data-testid="avatar-image"
                style={{ '--size': size } as any}
            />
        ) : (
            <div
                className={styles.avatar}
                data-testid="avatar-letters"
                style={{ '--size': size, '--fontSize': fontSize } as any}
            >
                {getNameAcronyms()}
            </div>
        );
    };

    let content = getAvatar();
    let openTooltip: boolean | undefined = true;
    if (tooltipText && tooltipOnHover) {
        openTooltip = undefined;
    }

    if (tooltipText) {
        content = (
            <div style={{ position: 'relative' }}>
                <Tooltip title={tooltipText} open={openTooltip} key={key} placement="top-start">
                    {getAvatar()}
                </Tooltip>
            </div>
        );
    }

    return content;
};

export default Avatar;
